export default {
  props: ['isMorePhotosSection'],
  computed: {
    sortParams() {
      return this.$store.getters.SORT_PARAMS;
    },
    currentSortParam() {
      return this.$store.getters.CURRENT_SORT_PARAM;
    },
    activeTag() {
      return this.$store.getters.CURRENT_TAG;
    },
    replacedPhotoProduct() {
      return this.$store.getters.REPLACED_PHOTO_DATA;
    },
    mobileSortingMenu() {
      return this.$store.getters.MOBILE_SORTING_MENU;
    },
  },
  methods: {
    async setActiveSortingItem(item) {
      if (this.isMobile) {
        this.$store.dispatch('SET_MOBILE_SORTING_MENU', false);
      }

      if (this.currentSortParam !== item) {
        this.$store.dispatch('SET_CURRENT_SORT_PARAM', item);

        let loader;

        if (this.isMorePhotosSection) {
          loader = this.$loading.show();
        } else {
          this.$store.dispatch('LOADING_PHOTOS_BY_PARAMS', true);
        }

        try {
          /*const tagId = this.isMorePhotosSection
              ? this.replacedPhotoProduct.image_tag.id
              : this.activeTag ? this.activeTag.id : '';*/

          const albumId = this.album.is_private
              ? `${this.album.hash}-${this.album.hash_password}`
              : this.album.id;

          const params = [];

          if (this.currentSortParam) {
            params.push(`sorting=${this.currentSortParam}`);
          }

          if (this.activeTag) {
            params.push(`tag=${this.activeTag.url_hash}`);
          } else if (this.$route.params.tag && (+this.album.hide_tags || !this.album.image_tags.length)) {
            params.push(`tag=${this.$route.params.tag}`);
          }

          const result = await this.axios.get(
              `/v2/albums/${albumId}/items${params.length > 0 ? `?${params.join('&')}` : ''}`);

          if (result && result.data.success) {
            this.$store.dispatch('SET_ALBUM_PHOTOS', result.data.data);
          }

          if (this.isMorePhotosSection) {
            loader.hide();
          } else {
            this.$store.dispatch('LOADING_PHOTOS_BY_PARAMS', false);
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e);
          this.$store.dispatch('LOADING_PHOTOS_BY_PARAMS', false);
        }
      }
    },
  },
};
